import React from 'react';
import { Routes, Route } from 'react-router-dom';
import NavigationBar from './components/navbar';
import Home from './pages/home';
import About from './pages/about';
import HeroSection from './pages/home';
import ServicesCards from './components/services';
import ContactSection from './components/contacform';
import BookingSystem from './pages/BookingSystem';

function App() {
  return (
    <div>
      <NavigationBar />
      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<ServicesCards />} />
        <Route path="/booking" element={<BookingSystem/>} />
      </Routes>
      <ContactSection/>
    </div>
  );
}

export default App;
